module.exports = __webpack_public_path__ + "img/coombs.0344b53b.jpg";